import React from 'react';
import './sec5.css'
import pic35 from '../assets/pic35.png'
import { useState } from 'react';


const Sec5 = () => {

  const [inView, setInView] = useState(false);


  const handleScroll = () => {
    const section = document.querySelector('.sec5');
    if (!section) return;
    const rect = section.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (isVisible !== inView) setInView(isVisible);
  };


window.addEventListener('scroll', handleScroll);
window.addEventListener('load', handleScroll);




    return ( 
        <section className='sec5'>
            <article   className={`big-cont-sec5 ${inView ? 'animate' : ''}`}>
            <article className='cont-sec5'>



               
            <article className='info-cont-sec5 '>
                <article className='info2-cont-sec5'>
                                <h1 className='header-sec5'>Fun Facts</h1>
                                <article className='container-text-sec5'>
                                    <p className='para-sec5'>She chose her lucky number 5 when naming Chanel No.
                                        5 because she believed it would bring her success.
                                        She even launched it on the fifth day of the fifth 
                                        month. The perfume became one of the most famous in 
                                        the world — and her lucky number truly worked!</p>
                                </article>

                                <img className='picc-sec5' src={pic35} alt='img'></img>
                </article>

                </article>
                 
            </article>


           

            </article>
        
        </section>
     );
}
 
export default Sec5;